import { WDJSErrorHandler } from 'wd-js-error-handler';

class WDLoginForm extends HTMLElement {
    static selectors = {
        wdLoginWrapper: 'wd-login-wrapper.wd-login-wrapper',
        OTPSMSInput: 'input[name="smsOTP"]#smsOTP',
        OTPSMSLabel: 'label[for="smsOTP"]',
        OTPSubmitButton: '.wd-login-otp-submit',
        OTPInput: '#otpInput',
        OTPInputLabel: 'label[for="otpInput"]',
        smsErrorMessage: '#smsErrorMessage',
        generalErrorMessage: '#generalErrorMessage',
        otpErrorMessage: '#otpErrorMessage',
        registerPhoneInput: 'input[name="phone"]',
        registerForm: 'wd-register-form.wd-register-form',
        otpFormOr: '.otp-form p.or',
        generalRegisterErrorMessage: '#generalRegisterErrorMessage',
        socialLoginWrapper: '.login-social-wrapper',
        loginDivider: '.wd-login-divider'
    };

    constructor() {
        super();
        this.err = new WDJSErrorHandler();
        this.attachEventListeners();
        this.initialGeneralError();
    };
    initialGeneralError() {
        const initialLoginError = localStorage.getItem('rdirect_to_login_and_err');
        if (initialLoginError) {
            this.displayError(initialLoginError);
            localStorage.removeItem('rdirect_to_login_and_err');
        }
    };
    attachEventListeners() {
        const submitButton = this.querySelector(WDLoginForm.selectors.OTPSubmitButton);
        if (submitButton) {
            submitButton.addEventListener('click', this.handleSubmit);
        } else {
            console.warn("Submit button not found in component.");
        }
        // Add Enter key support for form inputs
        const smsInput = this.querySelector(WDLoginForm.selectors.OTPSMSInput);
        const otpInput = document.querySelector(WDLoginForm.selectors.OTPInput);


        if (smsInput) {
            smsInput.addEventListener('keydown', (e) => {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    this.handleSubmit(e);
                }
            });
        }

        if (otpInput) {
            otpInput.addEventListener('keydown', (e) => {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    this.handleSubmit(e);
                }
            });
        }
    };

    handleSubmit = async (event) => {
        const isOTPMode = this.isOTPMode();

        if (isOTPMode) {
            await this.handleOTPSubmit(event);
        } else {
            await this.handleSendOTPSubmit(event);
        }
    }

    async handleSendOTPSubmit(event) {
        if (!this.isValid()) return;

        const requestData = this.getValidRequestData();
        if (!requestData || !requestData.phone) {
            this.displayError(" אנא הקלד כתובת אימייל או מספר טלפון תקינים.");
            return;
        }

        const response = await this.sendRequest('/apps/api/customers/otp', "POST", requestData);

        if (response.success) {
            console.log("OTP sent successfully:", response);
            this.changeToOTPMode();
            this.clearErrorMessages();
        } else {
            this.displayError(this.err.frontendError(response.message[0]) || "אירעה שגיאה במהלך שליחת ה-OTP. אנא נסה שוב.");
        }
    }

    async handleOTPSubmit(event) {
        if (!this.isValidOTP()) return;

        const otpInput = document.querySelector(WDLoginForm.selectors.OTPInput).value;
        const requestData = this.getValidRequestData(); // Get valid request data (email or phone)

        if (!requestData.phone) {
            this.displayError("אנא הקלד כתובת אימייל או מספר טלפון.");
            return;
        }
        // Add OTP code to the request data
        requestData.otpCode = otpInput;
        requestData.redirectUrl = window.location.href.replace('/login', '');

        const response = await this.sendRequest('/apps/api/customers/login', "POST", requestData);

        if (response.success) {
            // Flag for account page: one short SR announcement instead of a long auto-read
            sessionStorage.setItem('wd_post_login', '1');
            // Homepage account-link stores redirect_after_login=/account — drop it to avoid a 2nd load
            const redirectAfterLogin = localStorage.getItem('redirect_after_login');
            if (redirectAfterLogin) {
                try {
                    const stored = new URL(redirectAfterLogin, window.location.origin);
                    if (stored.pathname === '/account' || stored.pathname === '/account/') {
                        localStorage.removeItem('redirect_after_login');
                    }
                } catch (_) { /* ignore bad stored URL */ }
            }
            window.location.href = response.data; // Redirect after successful validation
        } else if (response.status === 404 && response.message[0] === "noCustomerFound") {
            await this.hideLoginForm();
            await this.showRegisterForm(requestData.phone);

            this.displayRegisterError(this.err.frontendError(response.message[0]) || "אירעה שגיאה במהלך אימות ה-OTP. אנא נסה שוב.");
        } else {
            this.displayError(this.err.frontendError(response.message[0]) || "אירעה שגיאה במהלך אימות ה-OTP. אנא נסה שוב.");
        }
    }
    async showRegisterForm(phone) {
        const registerElem = document.querySelector(WDLoginForm.selectors.registerForm);
        const registerFormPhoneInput = registerElem.querySelector(WDLoginForm.selectors.registerPhoneInput);
        if (!registerElem) return;
        registerElem.style.display = 'flex';
        if (registerFormPhoneInput) registerFormPhoneInput.value = phone || '';
        registerFormPhoneInput.disabled = registerFormPhoneInput.value ? true : false;
    }
    async hideLoginForm() {
        const loginElem = document.querySelector(WDLoginForm.selectors.wdLoginWrapper);
        if (!loginElem) return;
        loginElem.style.display = 'none';
    }
    async sendRequest(url, method, data = null) {
        try {
            const response = await fetch(`${window.location.origin}${url}`, {
                method: method,
                headers: {
                    'Content-Type': 'application/json'
                },
                ...(data ? { body: JSON.stringify(data) } : {})
            });

            if (!response.ok) {
                const errorData = await response.json();
                console.error("Error response from server:", errorData);
                if (response.status !== 500) {
                    return { success: false, message: errorData.message || "אירעה שגיאה במהלך הבקשה. אנא נסה שוב.", status: response.status };
                } else {
                    return { success: false, message: "אירעה שגיאה בשרת, אנא נסה שוב מאוחר יותר.", status: response.status };
                }
                return { success: false, message: "אירעה שגיאה במהלך הבקשה. אנא נסה שוב.", status: response.status };
            }

            return await response.json();
        } catch (error) {
            console.error("Error during API call:", error);
            this.displayError("אירעה שגיאה במהלך שליחת בקשה. אנא נסה שוב.");
            return { success: false };
        }
    }

    getValidRequestData() {
        const smsInput = this.querySelector(WDLoginForm.selectors.OTPSMSInput);

        const isPhoneValid = this.isValidPhone(smsInput.value);

        // If both are valid, prioritize phone and send phone only
        if (isPhoneValid) {
            return { phone: smsInput.value }; // Send only phone if it's valid
        }

        return null; // Return null if neither is valid
    }

    announceLoginScreenReader(message) {
        let el = document.getElementById('wd-login-step-announce');
        if (!el) {
            el = document.createElement('div');
            el.id = 'wd-login-step-announce';
            el.setAttribute('role', 'status');
            el.setAttribute('aria-live', 'polite');
            el.setAttribute('aria-atomic', 'true');
            el.style.cssText = 'position:absolute;left:-10000px;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0);';
            (this.querySelector('.wd-login') || this).appendChild(el);
        }
        el.textContent = '';
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                el.textContent = message;
            });
        });
    }

    changeToOTPMode() {
        this.toggleInputFields('none'); // Hide email and phone fields
        const submitBtn = document.querySelector(WDLoginForm.selectors.OTPSubmitButton);
        if (submitBtn) submitBtn.innerText = 'היכנס';
        const social = document.querySelector(WDLoginForm.selectors.socialLoginWrapper);
        if (social) social.style.display = 'none';
        const postOtpText = this.getAttribute('data-post-otp-text') || 'התחברו עם קוד אימות';
        const dividerP = this.querySelector(WDLoginForm.selectors.loginDivider + ' p');
        if (dividerP) {
            dividerP.textContent = postOtpText;
            dividerP.setAttribute('aria-label', postOtpText);
        }
        const otpInput = document.querySelector(WDLoginForm.selectors.OTPInput);
        const announcement = `${postOtpText}. קוד האימות נשלח ב-SMS. הזינו בשדה הבא קוד בן 6 ספרות.`;
        this.announceLoginScreenReader(announcement);
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                otpInput?.focus({ preventScroll: false });
            });
        });
    }


    toggleInputFields(phoneDisplay) {
        const phoneLabel = this.querySelector(WDLoginForm.selectors.OTPSMSLabel);
        const phoneInput = this.querySelector(WDLoginForm.selectors.OTPSMSInput);
        const otpInputOr = document.querySelector(WDLoginForm.selectors.otpFormOr);
        const phoneFieldset = phoneInput.parentElement;

        // Hide email and phone input fields visually, but keep them in DOM
        if (phoneInput) {
            phoneInput.style.display = phoneDisplay;
            if (phoneDisplay === 'none') {
                phoneInput.setAttribute('aria-hidden', 'true');
                phoneInput.setAttribute('tabindex', '-1');
            } else {
                phoneInput.removeAttribute('aria-hidden');
                phoneInput.setAttribute('tabindex', '0');
            }
        }
        if (phoneLabel) {
            phoneLabel.style.display = phoneDisplay;
            if (phoneDisplay === 'none') {
                phoneLabel.setAttribute('aria-hidden', 'true');
            } else {
                phoneLabel.removeAttribute('aria-hidden');
            }
        }
        if (phoneFieldset) phoneFieldset.style.display = phoneDisplay;
        if (otpInputOr) otpInputOr.style.display = phoneDisplay === 'none' ? 'none' : 'block';

        document.querySelector(WDLoginForm.selectors.OTPInput).style.display = 'block';
        document.querySelector(WDLoginForm.selectors.OTPInput).parentElement.style.display = 'block';
        document.querySelector(WDLoginForm.selectors.OTPInputLabel).style.display = 'block';

    }

    clearErrorMessages() {
        const smsErr = document.querySelector(WDLoginForm.selectors.smsErrorMessage);
        const gen = document.querySelector(WDLoginForm.selectors.generalErrorMessage);
        const otpErr = document.querySelector(WDLoginForm.selectors.otpErrorMessage);
        const smsInput = document.querySelector(WDLoginForm.selectors.OTPSMSInput);
        const otpInput = document.querySelector(WDLoginForm.selectors.OTPInput);

        if (smsErr) {
            smsErr.style.display = 'none';
            smsErr.textContent = '';
        }
        if (gen) {
            gen.style.display = 'none';
            gen.textContent = '';
        }
        if (otpErr) {
            otpErr.style.display = 'none';
            otpErr.textContent = '';
        }
        if (smsInput) {
            smsInput.style.border = '';
            smsInput.style.color = '';
            smsInput.style.backgroundColor = '';
            smsInput.setAttribute('aria-invalid', 'false');
            smsInput.removeAttribute('aria-describedby');
        }
        if (otpInput) {
            otpInput.style.border = '';
            otpInput.style.color = '';
            otpInput.style.backgroundColor = '';
            otpInput.setAttribute('aria-invalid', 'false');
            if (this.isOTPMode()) {
                otpInput.setAttribute('aria-describedby', 'wd-login-otp-divider-desc');
            } else {
                otpInput.removeAttribute('aria-describedby');
            }
        }
        const smsLabel = document.querySelector(WDLoginForm.selectors.OTPSMSLabel);
        const otpLabel = document.querySelector(WDLoginForm.selectors.OTPInputLabel);
        if (smsLabel) smsLabel.style.color = '';
        if (otpLabel) otpLabel.style.color = '';
    }

    displayError(message) {
        this.clearErrorMessages();
        const gen = document.querySelector(WDLoginForm.selectors.generalErrorMessage);
        gen.textContent = message;
        gen.style.display = 'block';
        requestAnimationFrame(() => {
            requestAnimationFrame(() => gen.focus());
        });
    }
    displayRegisterError(message) {
        document.querySelector(WDLoginForm.selectors.generalRegisterErrorMessage).textContent = message;
        document.querySelector(WDLoginForm.selectors.generalRegisterErrorMessage).style.display = 'block';
    }

    isValid() {
        const smsInput = this.querySelector(WDLoginForm.selectors.OTPSMSInput);

        const isPhoneValid = this.isValidPhone(smsInput.value);

        this.clearErrorMessages();

        let valid = true;

        if (!smsInput.value) {
            this.displayFieldError(WDLoginForm.selectors.OTPSMSInput, WDLoginForm.selectors.OTPSMSLabel, WDLoginForm.selectors.smsErrorMessage, "אנא הקלד מספר טלפון");
            valid = false;
        } else if (!isPhoneValid) {
            this.displayFieldError(WDLoginForm.selectors.OTPSMSInput, WDLoginForm.selectors.OTPSMSLabel, WDLoginForm.selectors.smsErrorMessage, "טלפון לא תקין");
            valid = false;
        }

        return valid;
    }

    displayFieldError(inputSelector, labelSelector, errorSelector, message) {
        const inputEl = document.querySelector(inputSelector);
        const labelEl = document.querySelector(labelSelector);
        const errEl = document.querySelector(errorSelector);
        const gen = document.querySelector(WDLoginForm.selectors.generalErrorMessage);

        if (gen) {
            gen.style.display = 'none';
            gen.textContent = '';
        }
        if (!inputEl || !errEl || !errEl.id) return;

        errEl.textContent = message;
        errEl.style.display = 'block';

        inputEl.style.border = '1px solid #C53120';
        inputEl.style.color = '#C53120';
        inputEl.style.backgroundColor = 'rgba(233, 79, 61, 0.15)';
        inputEl.setAttribute('aria-invalid', 'true');

        const describedByIds =
            inputEl.id === 'otpInput'
                ? ['wd-login-otp-divider-desc', errEl.id]
                : [errEl.id];
        inputEl.setAttribute('aria-describedby', describedByIds.join(' '));

        if (labelEl) labelEl.style.color = '#C53120';

        requestAnimationFrame(() => {
            requestAnimationFrame(() => inputEl.focus({ preventScroll: false }));
        });
    }



    isValidPhone(phone) {
        const re = /^\d{10}$/; // Example for a 10-digit phone number
        return re.test(String(phone));
    }

    isValidOTP() {
        const otpInputEl = document.querySelector(WDLoginForm.selectors.OTPInput);
        const otpValue = otpInputEl.value;
        const re = /^\d{6}$/;
        if (!re.test(otpValue)) {
            this.clearErrorMessages();
            this.displayFieldError(WDLoginForm.selectors.OTPInput, WDLoginForm.selectors.OTPInputLabel, WDLoginForm.selectors.otpErrorMessage, "הזן קוד בן 6 ספרות");
            return false;
        }
        this.clearErrorMessages();
        return true;
    }

    isOTPMode() {
        return document.querySelector(WDLoginForm.selectors.OTPInput).style.display === 'block';
    }
}

window.addEventListener('load', () => {
    customElements.define('wd-login-wrapper', WDLoginForm);
});
